<template>
  <v-content class="bg">
    <v-container fluid fill-height >
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Welcome to GPT Backoffice</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form v-on:keyup.enter="submit()">
                <v-text-field
                  prepend-icon="person"
                  name="login"
                  label="Login"
                  type="text"
                  v-model="username"
                  v-on:keyup.enter="submit()"
                ></v-text-field>
                <v-text-field
                  prepend-icon="lock"
                  name="password"
                  label="Password"
                  id="password"
                  type="password"
                  v-model="password"
                  v-on:keyup.enter="submit()"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="submit()" >Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
      <v-snackbar
        v-model="showErrorMessage"
        color="error"
        timeout="6000"
        top>
        Login Failed! Please check your login credentials and try again.
        <!-- <v-btn
          dark
          flat
          @click="snackbar = false"
        >
          Close
        </v-btn> -->
    </v-snackbar>
  </v-content>
</template>

<script>
    import { mapGetters } from "vuex"
    import SessionSliderWidget from "Components/Widgets/SessionSlider"
    import AppConfig from "Constants/AppConfig"

    export default {
        components: {
            SessionSliderWidget
        },
        data() {
            return {
                checkbox: false,
                valid: false,
                username: '',
                password: '',
                emailRules: [
                    v => !!v || "E-mail is required",
                    v =>
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "E-mail must be valid"
                ],
                passwordRules: [v => !!v || "Password is required"],
                appLogo: AppConfig.appLogo2,
                brand: AppConfig.brand,
                showErrorMessage: false
            }
        },
        methods: {
            submit() {
            this.$auth.login({
                username: this.username,
                password: this.password
            })
            .then(() => this.$router.push("/dashboard"))
            .catch(error => {
                this.showErrorMessage = true
            })

            }
        },
        created() {
            if (this.$store.state.auth.isLoggedIn) {
            this.$router.push("/dashboard")
            }
        }
    }
</script>
<style>
  .bg {
    background: url('~@/assets/bg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
</style>
